module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"header":"Padaliniai","departments":"Mūsų padaliniai","department":"Padalinys","departmentSite":"Padalinio svetainė"},"en":{"header":"Branches","departments":"Our branches","department":"Branch","departmentSite":"Branch page"}}')
  delete Component.options._Ctor
}
